import { render, staticRenderFns } from "./LmsHeader.vue?vue&type=template&id=494611bb"
import script from "./LmsHeader.vue?vue&type=script&lang=js"
export * from "./LmsHeader.vue?vue&type=script&lang=js"
import style0 from "./LmsHeader.vue?vue&type=style&index=0&id=494611bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports